const lang = {
  contact: 'İletişim',
  experience: 'Deneyim',
  education: 'Eğitim',
  skills: 'Yetenekler',
  about: 'Hakkımda'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/tr.js